// src/components/TaskCard.jsx
import { format, isPast, isToday } from "date-fns";
import { vi } from "date-fns/locale";
import "../styles/taskcard.css";

const PRIORITY_LABEL = { low: "Thấp", medium: "Trung bình", high: "Cao" };
const STATUS_LABEL = {
  todo: "Cần làm",
  in_progress: "Đang làm",
  in_review: "Xem xét",
  done: "Hoàn thành",
};

export default function TaskCard({ task, members, onEdit, onDelete, onStatusChange }) {
  const assignee = members?.find((m) => m.uid === task.assigneeId);
  const deadline = task.deadline?.toDate?.();
  const isOverdue = deadline && isPast(deadline) && task.status !== "done";
  const isDueToday = deadline && isToday(deadline);

  return (
    <div className={`task-card ${task.status === "done" ? "done" : ""}`}>
      {/* Priority stripe */}
      <div className={`priority-stripe priority-${task.priority || "medium"}`}/>

      <div className="task-card-body">
        <div className="task-card-top">
          {/* Status toggle */}
          <button
            className={`status-check ${task.status === "done" ? "checked" : ""}`}
            onClick={() => onStatusChange(task.id, task.status === "done" ? "todo" : "done")}
            title="Đánh dấu hoàn thành"
          >
            {task.status === "done" && (
              <svg width="10" height="10" viewBox="0 0 12 12" fill="none">
                <path d="M2 6l3 3 5-5" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            )}
          </button>

          <h4 className="task-title">{task.title}</h4>

          {/* Actions */}
          <div className="task-actions">
            <button className="task-action-btn" onClick={() => onEdit(task)} title="Sửa">
              <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
                <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/>
                <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/>
              </svg>
            </button>
            <button className="task-action-btn danger" onClick={() => onDelete(task.id)} title="Xóa">
              <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
                <polyline points="3 6 5 6 21 6"/>
                <path d="M19 6l-1 14H6L5 6"/>
                <path d="M10 11v6M14 11v6"/>
                <path d="M9 6V4h6v2"/>
              </svg>
            </button>
          </div>
        </div>

        {task.description && (
          <p className="task-desc">{task.description}</p>
        )}

        <div className="task-card-footer">
          {/* Status badge */}
          <span className={`status-badge status-${task.status}`}>
            {STATUS_LABEL[task.status]}
          </span>

          {/* Priority */}
          <span className={`priority-badge priority-text-${task.priority || "medium"}`}>
            {PRIORITY_LABEL[task.priority || "medium"]}
          </span>

          {/* Deadline */}
          {deadline && (
            <span className={`deadline-badge ${isOverdue ? "overdue" : isDueToday ? "today" : ""}`}>
              <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <circle cx="12" cy="12" r="10"/>
                <polyline points="12 6 12 12 16 14"/>
              </svg>
              {format(deadline, "dd/MM", { locale: vi })}
              {isOverdue && " (trễ)"}
              {isDueToday && " (hôm nay)"}
            </span>
          )}

          {/* Assignee */}
          {assignee && (
            <div className="assignee-chip">
              {assignee.photoURL ? (
                <img src={assignee.photoURL} alt="" className="assignee-avatar"/>
              ) : (
                <div className="assignee-avatar-fallback">
                  {assignee.displayName?.charAt(0)}
                </div>
              )}
              <span>{assignee.displayName?.split(" ").pop()}</span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
